



































import { Component, Prop, Vue } from "vue-property-decorator";
import InvoiceInfo from "@/models/InvoiceInfo";
import { InvoiceTypes } from "../Constants";

@Component
export default class SubmissionFormInvoiceInfo extends Vue {
  @Prop() private invoiceInfo!: InvoiceInfo;
  private invoiceTypes = InvoiceTypes.ALL;
}
